// extracted by mini-css-extract-plugin
module.exports = {"page":"app_page__C7eBd","page-body":"app_page-body__Ef2jB","page-loading":"app_page-loading__3j3d4","loading":"app_loading__kQTTt","loader":"app_loader__f_2nQ"};